import React, { useState, useEffect } from 'react';
import { Button, Col, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVoteYea } from '@fortawesome/free-solid-svg-icons';

//Helpers
import { getSessionCookie } from '../../../../helpers/cookies';
import { showMessage } from '../../../../helpers/message';

//Components
import TabelaListagemFichas from '../../../../components/TabelaListagemFichas/TabelaListagemFichas';
import TextField from '../../../../components/TextField';
import ModalCustomized from '../../../../components/Modal/Modal';

//API
import colegiadoVotacao_api from '../../../../api/colegiadoVotacao_api';

//Context
import { useAuth } from '../../../../context/auth';

function VotacaoColegiado({ acaoVotacao, loadAcoesPendentes, loadInfracaoItem }) {
    //State para visibilidade do modal de votação
    const [modalVisibleVotacao, setModalVisibleVotacao] = useState(false);

    //Função para mudar o state do modal votação
    const toggleModalVotacao = () => setModalVisibleVotacao(!modalVisibleVotacao);

    //State para pegar o usuário caso seja etapa de votação
    const [votacaoColegiado, setVotacaoColegiado] = useState(null);

    const [textoAlertaVotacao, setTextoAlertaVotacao] = useState(false);

    const session = getSessionCookie();

    const { setLoading } = useAuth();

    //Cabeçalhos da lista de consulta infração
    const headersVotocao = [
        { value: "Usuário", objectValue: "usuario", align: "left" },
        { value: "Voto", objectValue: "voto", align: "left" },
        { value: "Data/Hora", objectValue: "dataHora", align: "left", formatDate: true },
        { value: "Observação", objectValue: "observacoes", align: "left" },
    ];

    useEffect(() => {
        if (session != null &&
            acaoVotacao?.length == acaoVotacao?.filter(x => x.voto == "Pendente")?.length &&
            acaoVotacao?.filter(x => x.usuario == session.nome && x.relator && x.voto == "Pendente")?.length > 0) {
            setVotacaoColegiado({
                id: acaoVotacao.filter(x => x.usuario == session.nome)[0].id,
                usuario_Id: session.id,
                fiscalizacaoInfracao_Id: acaoVotacao.filter(x => x.usuario == session.nome)[0].fiscalizacaoInfracao_Id,
                roteiroFiscalizacaoEtapa_Id: acaoVotacao.filter(x => x.usuario == session.nome)[0].roteiroFiscalizacaoEtapa_Id,
                observacoes: "",
                voto: ""
            });
            setTextoAlertaVotacao(false)
        }
        else if (session != null && acaoVotacao?.length == acaoVotacao?.filter(x => x.voto == "Pendente")?.length) {
            setTextoAlertaVotacao(true);
        }
        else if (session != null &&
            acaoVotacao?.length != acaoVotacao?.filter(x => x.voto == "Pendente")?.length &&
            acaoVotacao?.filter(x => x.usuario == session.nome && !x.relator && x.voto == "Pendente")?.length > 0
        ) {
            setVotacaoColegiado({
                id: acaoVotacao.filter(x => x.usuario == session.nome)[0].id,
                usuario_Id: session.id,
                fiscalizacaoInfracao_Id: acaoVotacao.filter(x => x.usuario == session.nome)[0].fiscalizacaoInfracao_Id,
                roteiroFiscalizacaoEtapa_Id: acaoVotacao.filter(x => x.usuario == session.nome)[0].roteiroFiscalizacaoEtapa_Id,
                observacoes: "",
                voto: ""
            });
            setTextoAlertaVotacao(false)
        }
    }, [acaoVotacao]);

    const onChangeVotacao = (e) => {
        const { name, value } = e.target;
        setVotacaoColegiado({
            ...votacaoColegiado,
            [name]: value
        })
    };

    const onSumitVotacaoColegiado = (voto) => {
        const _votacaoColegiado = {
            ...votacaoColegiado,
            voto
        };

        setLoading(true);
        colegiadoVotacao_api.PostUsuarioVotacao(_votacaoColegiado)
            .then(response => {
                loadAcoesPendentes();
                loadInfracaoItem();
                setVotacaoColegiado(null);
                toggleModalVotacao();
            })
            .catch(err => showMessage("Error", err?.message ?? "Erro na operação", "error", null))
            .finally(() => setLoading(false))
    };

    return <>
        <ModalCustomized
            title={"Votação colegiado"}
            toggle={toggleModalVotacao}
            isOpen={modalVisibleVotacao}
            btnClose={toggleModalVotacao}
        >
            <Row>
                <Col md={12} lg={12}>
                    <TextField
                        name={"observacoes"}
                        label={"Observações"}
                        type={"textarea"}
                        onChange={onChangeVotacao}
                        value={votacaoColegiado?.observacoes}
                    />
                </Col>

                <div className="d-flex justify-content-center gap-2">
                    <Button color='success' onClick={() => onSumitVotacaoColegiado("Aprovado")}>
                        Aprovar
                    </Button>
                    <Button color='danger' onClick={() => onSumitVotacaoColegiado("Reprovado")}>
                        Reprovar
                    </Button>
                </div>
            </Row>
        </ModalCustomized>
        {votacaoColegiado &&
            <Row className='px-3 py-1 d-flex justify-content-end mb-2'>
                <Col md={12} lg={2}>
                    <Button
                        color='primary'
                        className='text-white fw-bold w-100'
                        onClick={() => { setModalVisibleVotacao(true) }}
                    >
                        <FontAwesomeIcon size='xs' icon={faVoteYea} /> Votar
                    </Button>
                </Col>
            </Row>
        }

        {acaoVotacao?.length > 0 && session != null &&
            <Row className='px-3 py-1'>
                <Col>
                    <TabelaListagemFichas
                        title={<>{textoAlertaVotacao && <span className='text-danger'>Aguardando parecer do relator</span>}</>}
                        options={{ print: false, search: true, pagination: true }}
                        headers={headersVotocao}
                        items={acaoVotacao}
                    />
                </Col>
            </Row>
        }
    </>
}

export default VotacaoColegiado;